import { defineMessages } from 'react-intl'

const messages = defineMessages({
    ReportTable_title: {
        id: 'SubHeader.ReportTable_title',
        description: '',
        defaultMessage: 'Panel de diagnóstico del Informe de Competitividad del País Vasco'
    },
    ReportTable_lastUpdated: {
        id: 'SubHeader.ReportTable_lastUpdated',
        description: '',
        defaultMessage: 'Actualizado a <strong>{ lastUpdated }</strong>'
    },
    ReportTable_p1: {
        id: 'SubHeader.ReportTable_p1',
        description: '',
        defaultMessage: 'Con el objetivo de proporcionar un <strong>diagnóstico más detallado</strong> para el <strong>País Vasco</strong>, este nuevo panel presenta una serie de indicadores de desempeño económico-empresarial, bienestar y palancas que forman parte del <a href={ methodologyLink }>marco de competitividad Orkestra</a>. Este enfoque amplía la perspectiva de la comparativa regional al incorporar <strong>nuevos indicadores</strong> disponibles únicamente para el País Vasco, así como para los niveles nacional y de la Unión Europea.'
    },
    ReportTable_p2: {
        id: 'SubHeader.ReportTable_p2',
        description: '',
        defaultMessage: 'Puedes moverte entre las dimensiones del marco con el siguiente mini mapa y volver al inicio desde el encabezado de cada dimensión. Al hacer clic en cualquier indicador, se accederá a un gráfico de evolución comparativa que incluye, además del País Vasco y la UE-27, las líneas de tendencia de España, Alemania y las regiones comparables (Alta Austria y Baden-Wurtemberg), siempre que estén disponibles.'
    },
    ReportTable_instructions_title: {
        id: 'SubHeader.ReportTable_instructions_title',
        description: '',
        defaultMessage: 'Cómo leer el panel'
    },
    ReportTable_instructions_paragraph: {
        id: 'SubHeader.ReportTable_instructions_paragraph',
        description: '',
        defaultMessage: `Se presenta una visión más sintética del nivel y la evolución de los indicadores en comparación con la Unión Europea, utilizando un código de colores y símbolos de fácil interpretación. El <span class="positive">color</span> verde indica un resultado positivo, el <span class="negative">color rojo</span> señala un resultado negativo y el <span class="stable">color gris</span> representa una diferencia nula o muy pequeña.
<ul>
    <li>La primera columna muestra la evolución interanual del País Vasco; un símbolo indica que la diferencia se encuentra entre el 1% y el 5%, mientras que dos símbolos indican que la diferencia supera el 5%.</li>
    <li>La segunda columna compara el valor del País Vasco con el de la UE-27, empleando un símbolo para diferencias entre el 1% y el 5%, y dos símbolos para diferencias superiores al 5%.</li>
    <li>La tercera columna recoge la comparativa de la evolución interanual del indicador para el País Vasco frente a la evolución de la UE-27. En este caso, un símbolo indica que el cambio en el País Vasco difiere entre 0.5 y 3 puntos porcentuales en relación con el cambio en la UE-27, mientras que dos símbolos señalan que la diferencia es superior a 3 puntos porcentuales.</li>
    <li>En los tres casos, si la diferencia es inferior a los valores indicados, se indica con un signo de igual.</li>
    <li>Finalmente, al pasar el cursor por encima de los símbolos o hacer click en ellos, se mostrarán los valores subyacentes asociados a cada uno de ellos.</li>
</ul>`
    }

});

export default messages;


// WEBPACK FOOTER //
// ./src/components/ReportTableSubheader/messages.js